<div class="form-group checkbox-wrapper" [ngClass]="divClass" [class.label-after]="labelAfter">
  <label [for]="inputId" *ngIf="!suppressLabel && !labelAfter" class="checkbox-label" [ngClass]="labelClass">
    {{ translateTag | translate }}
    <i *ngIf="tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
  </label>
  <div class="checkbox-input-wrapper">
    <input
      *ngIf="!useYesNo"
      type="checkbox"
      class="form-check-input quadratic-checkbox"
      [ngClass]="renderStatic ? 'form-control-plaintext' : 'form-control'"
      [readonly]="renderStatic"
      [id]="inputId"
      [name]="inputId"
      [required]="required"
      [disabled]="disabled"
      [placeholder]="placeholder | translate"
      [(ngModel)]="value"
    />
    <input
      *ngIf="useYesNo"
      type="checkbox"
      class="form-check-input quadratic-checkbox"
      [ngClass]="renderStatic ? 'form-control-plaintext' : 'form-control'"
      [readonly]="renderStatic"
      [id]="inputId"
      [name]="inputId"
      [required]="required"
      [disabled]="disabled"
      [placeholder]="placeholder | translate"
      [checked]="value === 'YES'"
      (change)="value = $event.target.checked ? 'YES' : 'NO'"
    />
  </div>
  <label [for]="inputId" *ngIf="!suppressLabel && labelAfter" class="checkbox-label" [ngClass]="labelClass">
    {{ translateTag | translate }}
    <i *ngIf="tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
  </label>
</div>
